import React from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaChevronRight } from "react-icons/fa";

const getCardClass = (index) => {
  if (index === 1) {
    return "overflow-hidden rounded-[16px] bg-white p-4 shadow-[0_14px_36px_rgba(118,9,130,0.14)]";
  }

  return "overflow-hidden rounded-[16px] border border-[#D4C4E8] bg-white p-4";
};

const LatestNews = ({ newsItems }) => {
  const items = Array.isArray(newsItems) ? newsItems : [];

  if (items.length === 0) return null;

  return (
    <section className="relative bg-white py-16 md:py-20 lg:py-24">
      <div className="relative z-10 mx-auto max-w-7xl px-4 md:px-8">
        <div className="text-center">
          <p className="text-[18px] font-bold text-brand-orange">Latest Blogs</p>
          <h2 className="mt-2 text-3xl font-bold text-brand-purple md:text-4xl lg:text-[2.5rem]">
            Our Latest Blogs
          </h2>
        </div>

        <div className="relative mt-10 md:mt-12">
          <div className="relative z-[2] grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8 lg:grid-cols-3">
            {items.map((item, index) => (
              <article key={item.id} className={getCardClass(index)}>
                <img src={item.image} alt={item.title} className="" />

                <div className="px-1 pb-2 pt-5">
                  <div className="flex items-center gap-2 text-brand-orange">
                    <FaCalendarAlt className="text-[14px]" aria-hidden="true" />
                    <time className="text-[14px] font-medium">{item.date}</time>
                  </div>

                  <h3 className="mt-3 text-[17px] font-bold leading-snug text-brand-purple md:text-[18px]">
                    {item.title}
                  </h3>

                  <Link
                    to={item.to}
                    className="mt-5 inline-flex items-stretch overflow-hidden rounded-[6px] border-2 border-brand-purple"
                  >
                    <span className="flex items-center px-4 py-2 text-[14px] font-medium text-brand-purple">
                      Read More
                    </span>
                    <span className="flex items-center bg-brand-purple px-2 py-2 m-1 text-white rounded-md">
                      <FaChevronRight className="text-[12px]" aria-hidden="true" />
                    </span>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestNews;
